<template>
  <h1>404 Page Not Found</h1>
</template>

<script>
/** @class NotFoundPage */
export default {
  name: 'NotFoundPage',
};
</script>
